import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

export const PageHero = ({ title, subtitle, eyebrow, highlights }) => (
  <section className="bg-gradient-to-br from-[#15348C] to-[#0A1F5C] text-white py-16 relative overflow-hidden">
    {/* Top accent hairline with a light shimmer sweep */}
    <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-[#15348C] via-[#6BBE32] to-[#8BD835] z-10 overflow-hidden">
      <div
        className="sg-shimmer absolute inset-0"
        style={{ backgroundImage: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.9) 50%, transparent 100%)" }}
      />
    </div>

    {/* Slowly drifting diamond crosshatch texture */}
    <div
      className="sg-grid-drift absolute inset-0 opacity-[0.07]"
      style={{
        backgroundImage:
          "repeating-linear-gradient(45deg, rgba(255,255,255,0.55) 0px, rgba(255,255,255,0.55) 1px, transparent 1px, transparent 18px), repeating-linear-gradient(-45deg, rgba(255,255,255,0.55) 0px, rgba(255,255,255,0.55) 1px, transparent 1px, transparent 18px)",
      }}
    />
    {/* Radial fade so the crosshatch is strongest behind the headline and dissolves toward the edges */}
    <div
      className="absolute inset-0"
      style={{ background: "radial-gradient(ellipse 60% 70% at 50% 40%, transparent 0%, rgba(10,31,92,0.55) 100%)" }}
    />

    {/* Soft floating color blobs for depth */}
    <div className="sg-float-a pointer-events-none absolute -top-20 right-10 w-72 h-72 bg-[#6BBE32]/15 rounded-full blur-3xl"/>
    <div className="sg-float-b pointer-events-none absolute -bottom-20 left-10 w-72 h-72 bg-[#8BD835]/15 rounded-full blur-3xl"/>
    <div className="sg-float-c pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[28rem] h-[28rem] bg-[#15348C]/20 rounded-full blur-3xl"/>

    <div className="relative max-w-7xl mx-auto px-4 text-center">
      <Reveal>
        {eyebrow && (
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest text-[#8BD835] mb-3 bg-white/10 border border-white/10 rounded-full px-3 py-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#8BD835]" />
            {eyebrow}
          </div>
        )}
        <h1 className="text-4xl lg:text-6xl font-bold tracking-tight drop-shadow-sm">{title}</h1>
        <p className="mt-4 text-gray-200 text-base lg:text-lg leading-relaxed max-w-3xl mx-auto">{subtitle}</p>
        {highlights && highlights.length > 0 && (
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            {highlights.map((h, i) => (
              <span
                key={h}
                className="sg-chip inline-flex items-center gap-1.5 text-sm font-semibold bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 hover:bg-white/20 hover:border-[#8BD835]/50"
                style={{ animationDelay: `${300 + i * 90}ms` }}
              >
                <CheckCircle2 size={14} className="text-[#8BD835]" />
                {h}
              </span>
            ))}
          </div>
        )}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
